export default "__VITE_ASSET__29052367__"